<div class="main-db gap-top">
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-12 col-sm-10">
        <h1>{{ title }}</h1>
      </div>
      <div class="col-12 col-sm-2 mb-2">
        <button class="btn btn-sm btn-success float-right" (click)="addVehicleDialog()"><i class="fas fa-plus mr-1"></i> Add
          Vehicle</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <div class="table-responsive db-block" style="height: auto !important">
          <i class="fa fa-database mr-2" aria-hidden="true"></i>
          <span>{{ title }}</span>
          <table
            mat-table
            [dataSource]="dataSource"
            class="gridData mt-2"
            matSort
          >
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>
            <ng-container matColumnDef="make">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Make</th>
              <td mat-cell *matCellDef="let element">{{ element.make }}</td>
            </ng-container>
            <ng-container matColumnDef="model">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Model</th>
              <td mat-cell *matCellDef="let element">
                {{ element.model }}
              </td>
            </ng-container>

            <ng-container matColumnDef="lpn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>License Plate</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.lpn }}
                </td>
              </ng-container>
              <ng-container matColumnDef="peoId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Officer Name</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.peoId.firstName + element.peoId.lastName}}
                </td>
              </ng-container>
              <ng-container matColumnDef="cameraGroupId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Camera Group</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.cameraGroupId.groupName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.createdDate | date : "y-MM-dd HH:mm:ss" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">

                  <button mat-icon-button matTooltip="Click to Edit" (click)="updateVehicleDialog(element)" class="iconbutton text-warning float-left">
                    <mat-icon aria-label="Edit">edit</mat-icon>
                  </button>

                  <button mat-icon-button  matTooltip="Click to Delete" (click)="getTempId(element)" class="iconbutton text-danger" data-toggle="modal" data-target="#deletePromptU">
                    <mat-icon aria-label="Delete">delete</mat-icon>
                  </button> 
                  
                  <div class="modal fade" id="deletePromptU" tabindex="-2" role="dialog" aria-labelledby="deletePromptLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title orange-text" id="deletePromptLabel">Delete Geofence </h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          </div>
                          <div class="modal-body">
                            Are you sure you want to delete this vehicle?
                          </div>
                          <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                          <button type="button" class="btn btn-danger" (click)="deleteVehicle(tempId)" data-dismiss="modal">Confirm</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
